// PURE easing for DOM FX (juice.json `easing`): Back.out with the data's overshoot (the snap-back, §2.7
// "Snap-back 180 ms Back.out"). Phaser's Back.out is the same formula.

/** Back.out: overshoots past 1 and settles; `s` = juice.json easing.popOvershoot. */
export function backOut(t: number, s: number): number {
  const c = t < 0 ? 0 : t > 1 ? 1 : t;
  const u = c - 1;
  return u * u * ((s + 1) * u + s) + 1;
}
